import { render } from "./SizeChartModal.vue?vue&type=template&id=6890174e"
import script from "./SizeChartModal.vue?vue&type=script&lang=js"
export * from "./SizeChartModal.vue?vue&type=script&lang=js"

import "./SizeChartModal.vue?vue&type=style&index=0&id=6890174e&lang=scss"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.7.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__